import { ColumnsType } from 'antd/es/table';
import TcTable from 'components/UI/Table/TcTable';
import endpointUrls from 'global/Constants/endpointUrls';
import { handleApiThenGeneric } from 'global/helperFunctions/handleApiThen';
import { localApiCatcher } from 'global/helperFunctions/localApiCatcher';
import { peopleAddress, peopleAddressCustomerLinkLocationsFromJet } from 'global/Models/addressModel';
import { IBackendGetGeneric } from 'global/Models/globalModels';
import ApiService, { errorResponse } from 'global/utils/ApiService';
import { FC, useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from 'redux/store';

interface props {
  defaultAddress: peopleAddressCustomerLinkLocationsFromJet[] | undefined;
  setAddress: (_address: peopleAddress) => void;
}
const OrderPeopleAddresCustomerLinkLocation: FC<props> = ({ defaultAddress, setAddress }) => {
  //state
  const [selectedAddress, setSetSelectedAddress] = useState<peopleAddressCustomerLinkLocationsFromJet>();
  const [loading, setLoading] = useState<boolean>(false);
  const userProfile = useSelector((state: RootState) => state.user.userProfile);
  const mountedRef = useRef(true);

  // Track mount state — set true in effect for StrictMode compatibility
  useEffect(() => {
    mountedRef.current = true;
    return () => {
      mountedRef.current = false;
    };
  }, []);

  //func — useCallback prevents effect re-run & double API call
  const handleCreateAddress = useCallback(
    async (selectedAddress: peopleAddressCustomerLinkLocationsFromJet) => {
      const location = [selectedAddress?.lat, selectedAddress?.long];
      const payload: any = {
        title: 'آدرس پیشنهادی',
        personId: userProfile?.personId,
        peopleAddressTypeId: 2,
        address: {
          fullAddress: selectedAddress.address,
          latitude: location ? location[0] : null,
          longitude: location ? location[1] : null,
          cityId: selectedAddress.igtCityId,
          linkAddressId: selectedAddress?.id,
        },
      };
      setLoading(true);
      await ApiService.post(endpointUrls.addressCreate, payload)
        .then((res: IBackendGetGeneric<peopleAddress>) =>
          handleApiThenGeneric<IBackendGetGeneric<peopleAddress>, peopleAddress>({
            res,
            notifFail: true,
            notifSuccess: false,
            onSuccessData: (data) => {
              if (mountedRef.current) {
                setAddress(data);
              }
            },
          })
        )
        .catch(() => {
          if (mountedRef.current) {
            localApiCatcher(errorResponse);
          }
        });
      if (mountedRef.current) {
        setLoading(false);
      }
    },
    [userProfile?.personId, setAddress]
  );

  //effect
  useEffect(() => {
    if (selectedAddress) {
      handleCreateAddress(selectedAddress);
    }
  }, [selectedAddress, handleCreateAddress]);

  //constant — memoized since setSetSelectedAddress is a stable useState setter
  const columns: ColumnsType<peopleAddressCustomerLinkLocationsFromJet> = useMemo(
    () => [
      { title: 'شهر', dataIndex: 'cityName', key: 'cityName' },
      { title: 'آدرس', dataIndex: 'address', key: 'address' },
      { title: 'شماره', dataIndex: 'mobileNumber', key: 'mobileNumber' },
      {
        title: 'انتخاب',
        key: 'select',
        dataIndex: 'select',
        render: (_text: string, record) => (
          <span
            className='cursor-pointer text-t-secondary-color hover:underline'
            onClick={() => {
              setSetSelectedAddress(record);
            }}>
            انتخاب
          </span>
        ),
      },
    ],
    []
  );

  return <TcTable columns={columns} dataSource={defaultAddress || []} loading={loading} />;
};
export default OrderPeopleAddresCustomerLinkLocation;
